'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('antd');

var _Input = require('../Input');

var _Input2 = _interopRequireDefault(_Input);

var _PhoneNumberInput = require('../PhoneNumberInput');

var _PhoneNumberInput2 = _interopRequireDefault(_PhoneNumberInput);

var _Checkbox = require('../Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _utils = require('shared/utils');

var _isSp = require('../../utils/isSp');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FormItem = _antd.Form.Item;
var TextArea = _antd.Input.TextArea;

var inputTypeRender = function inputTypeRender(type, props, inputValue) {
  var autoComplete = props.autoComplete,
      placeholder = props.placeholder,
      addonBefore = props.addonBefore,
      addonBeforeClassName = props.addonBeforeClassName,
      IconAction = props.IconAction,
      addonAfter = props.addonAfter,
      disabled = props.disabled,
      allowClear = props.allowClear,
      style = props.style,
      text = props.text,
      min = props.min,
      max = props.max,
      id = props.id,
      icon = props.icon,
      rows = props.rows,
      className = props.className,
      required = props.required,
      cols = props.cols;
  var displayPlaceholder = required ? "".concat(placeholder, " *") : placeholder;

  switch (type) {
    case 'textarea':
      return _react2.default.createElement(TextArea, _extends({
        prefix: icon && _react2.default.createElement(_antd.Icon, {
          type: icon,
          onClick: IconAction && IconAction
        })
      }, inputValue, {
        placeholder: displayPlaceholder,
        type: type,
        rows: rows,
        cols: cols,
        style: style,
        className: className,
        id: id ? id : null,
        min: min,
        max: max,
        disabled: disabled,
        autoComplete: autoComplete || 'on'
      }, addonBefore ? addonBefore = {
        addonBefore: addonBefore
      } : ''));

    case 'checkbox':
      var isChecked = props.useLocalChecked ? props.checked : !!inputValue.value;
      return _react2.default.createElement(_Checkbox2.default, {
        checked: isChecked,
        onChange: function onChange(e) {
          if (props.onCheckboxChange) props.onCheckboxChange(e.target.checked);
          inputValue.onChange(e);
        },
        disabled: disabled,
        style: style,
        className: className
      }, text);

    case 'phone-number':
      {
        return _react2.default.createElement(_PhoneNumberInput2.default, _extends({}, inputValue, {
          allowClear: allowClear,
          disabled: disabled,
          style: style,
          placeholder: displayPlaceholder,
          className: className
        }));
      }

    default:
      return _react2.default.createElement(_Input2.default, _extends({
        prefix: icon && _react2.default.createElement(_antd.Icon, {
          type: icon,
          onClick: IconAction && IconAction
        })
      }, inputValue, {
        placeholder: displayPlaceholder,
        type: type,
        rows: rows,
        style: style,
        className: className,
        id: id ? id : null,
        min: min,
        max: max,
        addonAfter: addonAfter ? _react2.default.createElement('span', {
          style: {
            color: (0, _isSp.isSp)() ? '#1A1A1A' : '#D3D4D9'
          }
        }, addonAfter) : null,
        disabled: disabled,
        autoComplete: autoComplete || 'on' // {...(addonBefore ? (addonBefore = { addonBefore }) : '')}
        ,
        addonBefore: addonBefore ? _react2.default.createElement('span', {
          className: addonBeforeClassName || ''
        }, addonBefore) : null
      }));
  }
};

var RenderField = function RenderField(props) {
  var labelCol = props.labelCol,
      wrapperCol = props.wrapperCol,
      label = props.label,
      formItemLayout = props.formItemLayout,
      type = props.type,
      className = props.className,
      containerClassName = props.containerClassName,
      _props$meta = props.meta,
      touched = _props$meta.touched,
      error = _props$meta.error,
      notRenderOnEmpty = props.notRenderOnEmpty,
      initialValue = props.initialValue,
      input = props.input,
      style = props.style;
  var value = initialValue ? {
    value: initialValue
  } : null;

  var inputValue = _extends({}, input, value);

  return !(0, _utils.isEmptyInput)(notRenderOnEmpty, input.value) && _react2.default.createElement(FormItem, _extends({
    validateStatus: touched && error && 'error' || '',
    labelCol: labelCol,
    label: label || '',
    wrapperCol: wrapperCol,
    help: touched && error,
    className: containerClassName
  }, formItemLayout), inputTypeRender(type, props, inputValue, style, className));
};

RenderField.defaultProps = {
  type: 'text',
  addonBefore: null
};
RenderField.propTypes = {
  input: _propTypes2.default.any,
  type: _propTypes2.default.string,
  wrapperCol: _propTypes2.default.object,
  labelCol: _propTypes2.default.object,
  addonBefore: _propTypes2.default.element,
  meta: _propTypes2.default.any,
  disabled: _propTypes2.default.bool,
  style: _propTypes2.default.any,
  className: _propTypes2.default.any,
  notRenderOnEmpty: _propTypes2.default.bool
};
exports.default = RenderField;